<!--
 * @Author: your name
 * @Date: 2020-10-15 17:14:27
 * @LastEditTime: 2020-10-29 10:07:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/views/workLocation/index.vue
-->
<template>
  <div class="work-location">
    <div class="img">
      <img
        src="https://oss.zhulogic.com/planImage/fa/877_dir/2fanAsTR2NSGN3ytSeW6XpjcX7P6c7B3G7.png"
        alt=""
      />
    </div>
    <div class="work-location-main pageWidtn">
      <work-search plNmae="请输入职位名称" @search="searchHandle"></work-search>
    </div>
    <div class="work-select pageWidtn">
      <Row :gutter="30" type="flex" justify="center" align="middle">
        <Col span="6">
          <Row :gutter="10" type="flex" justify="center" align="middle">
            <Col span="4"> <span class="work-name">学历</span></Col>
            <Col span="20">
              <Select
                @on-change="changeEducation"
                @on-clear="clearEducation"
                v-model="filter.education"
                clearable
                placeholder="请选择"
              >
                <Option
                  v-for="(item, index) in schooling"
                  :value="item.id"
                  :key="index"
                  >{{ item.desc }}</Option
                >
              </Select></Col
            >
          </Row>
        </Col>
        <Col span="6">
          <Row :gutter="10" type="flex" justify="center" align="middle">
            <Col span="4"> <span class="work-name">经验</span></Col>
            <Col span="20">
              <Select
                @on-change="changeExperience"
                @on-clear="clearExperience"
                v-model="filter.experience"
                clearable
              >
                <Option
                  v-for="(item, index) in experienceLists"
                  :value="item.id"
                  :key="index"
                  >{{ item.desc }}</Option
                >
              </Select>
            </Col>
          </Row>
        </Col>
        <Col span="6">
          <Row :gutter="10" type="flex" justify="center" align="middle">
            <Col span="4"> <span class="work-name">地址</span></Col>
            <Col span="20" class="select-address">
              <Cascader
                change-on-select
                @on-change="chiocedAddress"
                :data="addressData"
                v-model="addressVal"
              ></Cascader>
            </Col>
          </Row>
        </Col>

        <Col span="6">
          <Row :gutter="10" type="flex" justify="center" align="middle">
            <Col span="4"> <span class="work-name">性别</span></Col>
            <Col span="20">
              <Select
                @on-change="changeSex"
                @on-clear="clearSex"
                v-model="filter.sex"
                clearable
              >
                <Option :value="1">男</Option>
                <Option :value="2">女</Option>
              </Select>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>

    <div class="work-item-page pageWidtn" v-if="!pageLoading">
      <div v-if="workerLists.length > 0 && workerLists">
        <Row :gutter="27">
          <Col
            span="8"
            style="margin-bottom:26px"
            :key="index"
            v-for="(item, index) in workerLists"
          >
            <item-view :items="item"></item-view>
          </Col>
        </Row>

        <div
          class="pages"
          style="margin-top:50px"
          v-if="total > 0 && !pageLoading"
        >
          <z-page
            :total="total"
            :elevator="true"
            :pageSize="filter.pageSize"
            v-model="filter.pageNum"
            @changePageNum="handleChangePage"
          ></z-page>
        </div>
      </div>

      <div
        v-if="workerLists.length === 0"
        class="empty align-center"
        style="margin-top:100px"
      >
        <img src="@/assets/user/user-empty-2.png" alt style="width:120px" />
        <p class="name f-16 m-t-20">没找找到相关求职者</p>
      </div>
    </div>

    <div v-if="pageLoading" class="loading" style="margin-top:120px">
      <div class="align-center">
        <img style="width:100px;" src="@/assets/new-global.gif" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import workSearch from './components/search'
import itemView from './components/item-worker'
import { constructQueryParams } from '@/utils/queryParams.js'
export default {
  name: '',
  data() {
    return {
      busy: false,
      total: 10,
      pageLoading: false,
      filter: {
        pageSize: 18,
        pageNum: 1,
        education: '', // 学历
        experience: '', // 经验
        keyword: '', // 关键词
        sex: '',
        provinceId: '', // 省
        cityId: '', // 市
        locationId: '', // 区
      },
      schoolingVal: '',
      schooling: [],
      experience: '',
      experienceLists: [],
      addressDataVal: '',
      addressData: [],
      addressVal: '',

      workerLists: [],
    }
  },
  components: { workSearch, itemView },
  methods: {
    searchHandle(val) {
      this.filter.keyword = val
      this.getWorkLists()
    },
    initAddressData(list) {
      list.forEach((element) => {
        element.value = element.id
        element.label = element.name
        if (element.cities && element.cities.length > 0) {
          element.children = element.cities
          this.initAddressData(element.cities)
        }
      })
      return list
    },
    handleChangePage(val) {
      this.filter.pageNum = val
      this.getWorkLists()
    },

    // 获得工作位置
    getWorkLists() {
      this.pageLoading = true
      axios
        .get(`/designer_api/job_resume${constructQueryParams(this.filter)}`)
        .then((res) => {
          this.total = res.total
          this.workerLists = res.list || []
          this.pageLoading = false
        })
        .catch((err) => {
          this.pageLoading = false
        })
    },

    // 获得学历列表
    getEducation() {
      axios.get(`/designer_api/job/education`).then((res) => {
        this.schooling = res
      })
    },
    // 获得经验列表
    getExperience() {
      axios.get(`/designer_api/job/experience`).then((res) => {
        this.experienceLists = res
      })
    },
    changeEducation(val) {
      this.filter.education = val
      this.getWorkLists()
    },
    clearEducation(val) {
      this.filter.education = ''
      this.getWorkLists()
    },
    changeExperience(val) {
      this.filter.experience = val
      this.getWorkLists()
    },
    clearExperience() {
      this.filter.experience = ''
      this.getWorkLists()
    },
    changeSex(val) {
      this.filter.sex = val
      this.getWorkLists()
    },
    clearSex() {
      this.filter.sex = ''
      this.getWorkLists()
    },
    // 地址筛选
    chiocedAddress(val) {
      val[0] ? (this.filter.provinceId = val[0]) : (this.filter.provinceId = '')
      val[1] ? (this.filter.cityId = val[1]) : (this.filter.cityId = '')
      val[2] ? (this.filter.locationId = val[2]) : (this.filter.locationId = '')
      this.getWorkLists()
    },
  },
  created() {
    const address_name = 'vuejs__ZHULOGIC_ADDRESS' || 'ZHULOGIC_ADDRESS'
    let lists = JSON.parse(localStorage.getItem(address_name)).value
    if (lists) {
      this.addressData = this.initAddressData(lists)
    } else {
      axios.get('/designer_api/location').then((res) => {
        this.addressData = this.initAddressData(res)
      })
    }
    this.getEducation()
    this.getExperience()
    this.getWorkLists()
  },
}
</script>

<style lang="scss" scoped>
/deep/.ivu-select-single .ivu-select-selection {
  background: transparent;
  border: 1px solid #eeeeef;
}
.select-address {
  /deep/ .ivu-input {
    background: transparent;
    border: 1px solid #eeeeef;
  }
}
.work-location {
  background: #f3f5f9;
  padding-bottom: 50px;
  min-height: 500px;
  .img {
    width: 100%;
    max-height: 268px;
    min-height: 200px;
    overflow: hidden;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .work-location-main {
    margin-top: 60px;
  }
  .work-select {
    width: 1000px;
    margin: 0 auto;
    margin-top: 60px;
    .work-name {
      font-size: 14px;
      font-weight: 500;
      color: #666666;
    }
    /deep/ .ivu-select-placeholder {
      color: #666666;
    }
  }
  .work-item-page {
    margin-top: 60px;
  }
}
</style>
